'use client';

import Link from 'next/link';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';

export const WEBSITE_BUTTON_SX = {
  bgcolor: '#0a0a0a',
  color: '#fff',
  border: '1px solid #0a0a0a',
  borderRadius: 0,
  px: 3,
  py: 1.35,
  fontSize: 11,
  fontWeight: 500,
  letterSpacing: '0.14em',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
  '&:hover': {
    bgcolor: '#fff',
    color: '#0a0a0a',
    borderColor: '#0a0a0a',
  },
  // Keep solid black CTA when disabled (avoid MUI muted tan/grey).
  '&.Mui-disabled': {
    bgcolor: '#0a0a0a',
    color: '#fff',
    borderColor: '#0a0a0a',
    opacity: 0.4,
  },
};

/** Outlined secondary CTA for marketing flows (Back, Cancel, etc.). */
export const WEBSITE_SECONDARY_BUTTON_SX = {
  bgcolor: 'transparent',
  color: '#0a0a0a',
  border: '1px solid #0a0a0a',
  '&:hover': {
    bgcolor: '#0a0a0a',
    color: '#fff',
    borderColor: '#0a0a0a',
  },
  '&.Mui-disabled': {
    bgcolor: 'transparent',
    color: '#0a0a0a',
    borderColor: '#0a0a0a',
    opacity: 0.4,
  },
};

export default function WebsiteButton({ href, children, fullWidth = false, sx, ...props }) {
  const isLink = Boolean(href);

  return (
    <Button
      {...(isLink ? { component: Link, href } : {})}
      variant="contained"
      disableElevation
      fullWidth={fullWidth}
      sx={{ ...WEBSITE_BUTTON_SX, ...sx }}
      {...props}
    >
      {children}
    </Button>
  );
}

WebsiteButton.propTypes = {
  href: PropTypes.string,
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  sx: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.func]),
};
